import { render } from "./BaseModal.vue?vue&type=template&id=4930085c&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=4930085c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4930085c"],['__file',"src/components/BaseModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4930085c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4930085c', __exports__)) {
    api.reload('4930085c', __exports__)
  }
  
  module.hot.accept("./BaseModal.vue?vue&type=template&id=4930085c&scoped=true", () => {
    api.rerender('4930085c', render)
  })

}


export default __exports__